import React, { useState, useEffect } from "react";
import FileBrowser from "../../../../shared/fileBrowser/FileBrowser";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import styles from "./UploadDealerPricing.module.scss";
import Grid from "@mui/material/Grid";
import excelIcon from "../../../../imgs/excel-icon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import "react-datepicker/dist/react-datepicker.css";
import { withTranslation } from "react-i18next";
import { InfoIconWithMessage } from "../../../../shared/infoIcon/InfoIcon";
import UploadDealerPriceClient from "../../../../shared/clients/UploadDealerPriceClient";
import SubNav from "../../../../shared/subnav/SubNav";
import { BRANDS } from "../../../accessories/Brands";
import LoadDealerPricing from "./LoadDealerPricing";
import ShowInventoryData from "./ShowInventoryData";
import moment from "moment";
import { REGEX_LIST } from "../../../../common/Constants";
import commonStyles from "../../../../styles/common/CommonStyles.module.scss";
import { PricesApplied } from "../../../../shared/feedback/PricesApplied";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import MarketPreferencesClient from "../../../../shared/clients/MarketPreferencesClient";
import { base64FileDownload } from "../../../../utils/FileDownloadUtil";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import PublishOutlined from "@mui/icons-material/PublishOutlined";
import { KeyboardArrowDown } from "@mui/icons-material";
import subNavStyles from "../../../../shared/subnav/subNavStyles";
import ErrorProcessingDialog from "../../../../errors/ErrorProcessingDialog";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const StyledSaveAltIconWhite = styled(SaveAltIcon)({
  height: 18,
  margin: 2,
  width: 18,
  padding: 0,
  color: "#fff",
});

const StyledPublishAltIconWhite = styled(PublishOutlined)({
  width: 22,
  padding: 0,
  color: "#fff",
  textAlign: "center",
  height: "100%",
  marginTop: "-3px",
});

const PickUpStyledMenuItem = styled(MenuItem)({
  paddingTop: 5,
  paddingBottom: 5,
  paddingLeft: 10,
  paddingRight: 10,
  margin: 0,
  fontSize: 14,
  color: "#102b4e",
  lineHeight: 1.57,
  letterSpacing: 1.5,
  fontFamily: "FordAntenna-Regular, sans-serif",
});

const PickUpFormControl = styled(FormControl)({
  width: 250,
  background: "linear-gradient(to bottom, #164069, #102b4e)",
});

const SelectCustom = styled(Select)({
  background: "linear-gradient(to bottom, #164069, #102b4e)",
  color: "red",
});

const UploadDealerPricing = (props) => {
  const [file, setFile] = useState(null);
  const [displayDetails, setDisplayDetails] = useState(false);
  const [enablePublish, setEnablePublish] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState("");
  const [displayError, setDisplayError] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [editButtonDisable, setEditButtonDisable] = useState({});
  const [allChecked, setAllChecked] = useState(false);
  const [selectedPrices, setSelectedPrices] = useState([]);
  const [fileExtractingData, setFileExtractingData] = useState([]);
  const [pricesApplied, setPricesApplied] = useState(false);
  const [conversionRate, setConversionRate] = useState("1.0");
  const [pricesUploaded, setPricesUploaded] = useState(false);
  const [numberOfPricesUploaded, setNumberOfPricesUploaded] = useState(0);
  const [numberOfPricesPublished, setNumberOfPricesPublished] = useState(0);
  const [currentFilter, setCurrentFilter] = useState("all.all");
  const [errorMsg, setErrorMsg] = useState(null);
  const [ialErrorOpen, setIalErrorOpen] = useState(false);

  const restrictDropdown = false;
  const isMEXMarket = props.user.market === "MEX";

  useEffect(() => {
    setSelectedPrices(props.dealerInventoryPrices);
    setEffectiveDate(new Date());
    getMarketConversionRate();
  }, []);

  useEffect(() => {
    if (
      props.dealerInventoryPrices &&
      props.dealerInventoryPrices.length !== selectedPrices.length
    ) {
      setSelectedPrices(props.dealerInventoryPrices);
    } else if (
      props.dealerInventoryPrices &&
      selectedPrices &&
      props.dealerInventoryPrices.length === selectedPrices.length
    ) {
      let shouldUpdate = false;
      selectedPrices.forEach((prevPrice, index) => {
        if (
          props.dealerInventoryPrices[index] &&
          (prevPrice.currencyAdjustedPrice !==
            props.dealerInventoryPrices[index].currencyAdjustedPrice ||
            prevPrice.published !==
              props.dealerInventoryPrices[index].published ||
            prevPrice.modifiedDate !==
              props.dealerInventoryPrices[index].modifiedDate)
        ) {
          shouldUpdate = shouldUpdate || true;
        }
      });
      if (shouldUpdate) {
        setSelectedPrices(props.dealerInventoryPrices);
      }
    }
  }, [props.dealerInventoryPrices]);

  const onFileSelected = (fileParam) => {
    let validFileType = false;
    if (
      fileParam.type === "application/vnd.ms-excel" ||
      fileParam.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      validFileType = true;
    }
    if (fileParam.size > 1000000 || !validFileType) {
      setDisplayError(true);
      setFile(null);
      setDisplayDetails(false);
    } else {
      setFile(fileParam);
      setDisplayDetails(true);
      setDisplayError(false);
      setEnablePublish(true);
      setEffectiveDate(new Date());
    }
  };

  const handleInputChange = (event) => {
    if (
      event.target.value !== currentFilter &&
      event.target.value !== undefined
    ) {
      setCurrentFilter(event.target.value);

      const property = event.target.value.split(".")[0];
      const value = event.target.value.split(".")[1];
      const expression = { property: property, value: value };

      props.reloadWithFilteredData(expression);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const getCount = () => {
    const prices = selectedPrices;
    let count = 0;
    prices.length > 0 &&
      prices.forEach((price) => {
        if (price.checked) {
          count += 1;
        }
      });
    return count > 0 ? count : null;
  };

  const getCountForEdit = () => {
    const prices = selectedPrices;
    let isChanged = false;
    prices &&
      prices.length > 0 &&
      prices.forEach((price) => {
        if (!price.published) {
          isChanged = isChanged || true;
        } else {
          const propsPrice = props.dealerInventoryPrices.find(
            (propsprice) => price.vin === propsprice.vin
          );
          if (
            propsPrice &&
            propsPrice.currencyAdjustedPrice !== price.currencyAdjustedPrice
          ) {
            isChanged = isChanged || true;
          }
        }
      });
    if (!isChanged && !pricesApplied) {
      setPricesApplied(true);
    }
    return isChanged;
  };

  const toggleModal = () => {
    setOpenModal(!openModal);
    setDisplayDetails(false);
  };

  const getMarketConversionRate = () => {
    MarketPreferencesClient.getConversionRate()
      .then((response) => {
        let rate = 1.0;
        if (response.result.conversionRate) {
          rate = response.result.conversionRate;
        }
        setConversionRate(rate);
      })
      .catch(() => {})
      .finally(() => {
        props.hideOrShow(false);
      });
  };

  const EditReservationsHandler = () => {
    setIsEditable(!isEditable);
  };

  const uploadToExtractFile = () => {
    uploadDealerPrice(0);
  };

  const uploadDealerPriceToSave = () => {
    setOpenModal(false);
    uploadDealerPrice(1);
  };

  const uploadDealerPrice = (processType) => {
    setEnablePublish(false);
    props.hideOrShow(true);

    const formData = new FormData();
    formData.append("pricingDocument", file);
    formData.append("processType", processType);
    formData.append("conversionRate", conversionRate);

    addDealerInfoInFormData(props.user, formData);

    UploadDealerPriceClient.uploadDealerPrice(props.user, formData)
      .then((data) => {
        if (processType === 1) {
          removeFile();
          props.loadDealerInventoryPricingHistory();
          setNumberOfPricesUploaded(
            data &&
              data.dealerPricesDataList &&
              data.dealerPricesDataList[0].dealerInvPriceData &&
              data.dealerPricesDataList[0].dealerInvPriceData.length
          );
        } else {
          setFileExtractingData(
            data &&
              data.dealerPricesDataList &&
              data.dealerPricesDataList[0].dealerInvPriceData
          );
          setNumberOfPricesUploaded(
            data &&
              data.dealerPricesDataList &&
              data.dealerPricesDataList[0].dealerInvPriceData &&
              data.dealerPricesDataList[0].dealerInvPriceData.length
          );
        }
      })
      .catch(() => {})
      .finally(() => {
        props.hideOrShow(false);
        if (processType === 0) {
          toggleModal();
        } else if (processType === 1) {
          setPricesUploaded(true);
        }
      });
  };

  const addDealerInfoInFormData = (user, formData) => {
    user.dealerGroup.forEach((dealer) => {
      const dealerInfo = {
        dealerId: dealer.completeDealerId,
        commonId: dealer.commonId,
        mainDealer: dealer.dealerType === "HUB",
      };
      formData.append("dealerInfoJson", JSON.stringify(dealerInfo));
    });
  };

  const removeFile = () => {
    document.getElementById("xls-file").value = "";
    setFile(null);
    setDisplayDetails(false);
    setEnablePublish(true);
    setEffectiveDate("");
  };

  const getSubNav = () => {
    const CustomSubNavTabBody = () => {
      return (
        props.enableUpload !== undefined && (
          <>
            <div className={styles.uploadTermsAndConditions}>
              {props.enableUpload ? (
                <HasPermissionTo
                  perform={["dealerInventoryUpload:write"]}
                  permissions={props.user.permissions.rolePermissions}
                  render={() => {
                    return (
                      <div className={`${styles.tools}`}>
                        <div>
                          {props.user.dealerType === "HUB" && (
                            <>
                              <div
                                className={`${styles.download} ${styles.downloadPointer} ${styles.downloadFile}`}
                              >
                                <a
                                  href={null}
                                  onClick={downloadInvPriceTemplate}
                                  className={`${styles.download}`}
                                >
                                  <StyledSaveAltIconWhite />

                                  {props.t(
                                    "UploadDealerPrice.downloadTemplate"
                                  )}
                                </a>
                              </div>
                              <div
                                className={`${styles.tools} ${styles.download}`}
                              >
                                <div
                                  className={`${styles.download}`}
                                  title={props.t("UploadDealerPrice.tipText")}
                                >
                                  <FileBrowser
                                    fileType=".xls,.xlsx"
                                    onFileSelected={onFileSelected}
                                    id="xls-file"
                                  >
                                    <StyledPublishAltIconWhite />
                                    <a>
                                      {props.t(
                                        "UploadDealerPrice.fileHeaderText"
                                      )}
                                    </a>
                                  </FileBrowser>

                                  {displayError && (
                                    <div className={styles.warningDiv}>
                                      <div className={styles.warning}></div>
                                      <div className={styles.errorText}>
                                        {props.t("UploadDealerPrice.fileError")}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                        </div>

                        <div>
                          <PickUpFormControl
                            fullWidth={false}
                            className={`${styles.download}`}
                          >
                            <SelectCustom
                              IconComponent={() => (
                                <KeyboardArrowDown style={subNavStyles.icon} />
                              )}
                              name="filter"
                              id="pickUpfilter"
                              data-testid="filterDropDown"
                              className={styles.dropdown}
                              value={currentFilter}
                              onChange={handleInputChange}
                            >
                              {props.filters &&
                                props.filters.map((recordForFilterDropDown) => {
                                  return (
                                    <PickUpStyledMenuItem
                                      key={recordForFilterDropDown.value}
                                      value={recordForFilterDropDown.value}
                                    >
                                      <div>{recordForFilterDropDown.text}</div>
                                    </PickUpStyledMenuItem>
                                  );
                                })}
                            </SelectCustom>
                          </PickUpFormControl>
                        </div>
                      </div>
                    );
                  }}
                />
              ) : (
                <div id="termsHeaderWithWarning" className="pagePadding">
                  <InfoIconWithMessage
                    message={[
                      props.t("BusinessSettings.termsandConditionsHeader"),
                      " ",
                      <span
                        className={styles.previewTitleWarning}
                        key="maximumUploadWarning"
                      >
                        {props.t("BusinessSettings.maximumUploadWarning")}
                      </span>,
                    ]}
                  />
                </div>
              )}
            </div>
            {displayDetails && (
              <>
                <Grid
                  container
                  className={`${styles.effectiveBox} pagePaddingLeft`}
                  id="effectiveRow"
                >
                  <Grid item xs={4} className={styles.effectiveDateRow}>
                    <div className={styles.fileNameTextBox}>
                      <div>
                        <img src={excelIcon} />
                        <p>{file.name}</p>
                      </div>
                      <div
                        className={styles.clearImage}
                        id="removeFile"
                        onClick={removeFile}
                      >
                        <ClearIcon />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={8} className={styles.effectiveDateRow}>
                    <span className={styles.effectiveText}>
                      Effective From{" "}
                    </span>
                    <div className={styles.effectiveDateText}>
                      {moment(effectiveDate).toString()}
                    </div>
                  </Grid>
                </Grid>
                <div className={styles.publishButton}>
                  <Button
                    type="button"
                    onClick={uploadToExtractFile}
                    className="greenBtn"
                    id="publish-action-btn"
                    disabled={!enablePublish}
                  >
                    {props.t("UploadDealerPrice.publish")}
                  </Button>
                </div>
              </>
            )}
          </>
        )
      );
    };
    return (
      <SubNav
        id="SubNavBarHere"
        {...props}
        title={props.t("UploadDealerPrice.header")}
        displayDetails={displayDetails}
        renderSubHeader={false}
        showCustomDropdown={false}
        subHeader={null}
        restrictDropdown={restrictDropdown}
        dropDownValues={BRANDS}
        customSubNavTabBody={CustomSubNavTabBody}
      />
    );
  };

  const downloadInvPriceTemplate = () => {
    props.hideOrShow(true);
    UploadDealerPriceClient.downloadInvPriceTemplate(
      props.user,
      props.t("UploadDealerPrice.templateColumnNames")
    )
      .then((res) => {
        const filename = props.t("UploadDealerPrice.templateName") + ".xlsx";
        const BOM = "\uFEFF";
        const response = BOM + res;
        base64FileDownload(
          decodeURIComponent(response),
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          filename
        );
        props.hideOrShow(false);
      })
      .catch(() => {});
  };

  const addDealerObjectsInIALrequest = (user) => {
    const listOfDealers = [];
    let newDealerObj = {};

    user.dealerGroup.forEach((dealer) => {
      newDealerObj = {
        dealerId: dealer.completeDealerId,
        commonId: dealer.commonId,
        mainDealer: dealer.dealerType === "HUB",
      };
      listOfDealers.push(newDealerObj);
    });

    return listOfDealers;
  };

  const updateInventoryPrice = (event) => {
    const originalDisables = editButtonDisable;
    if (!event.target.value.match(REGEX_LIST.number) || !event.target.value) {
      originalDisables[event.target.name] = true;
    } else {
      originalDisables[event.target.name] = false;
    }

    const newPrices = selectedPrices.map((price) => {
      const newPrice = { ...price };
      if (event.target.name === newPrice.vin) {
        newPrice.currencyAdjustedPrice = event.target.value;
        newPrice.checked = false;
        newPrice.priceModified = true;
        if (props.user && props.user.market === "ARG") {
          newPrice.usdCustomerPrice = conversionRate * event.target.value;
        }
        if (props.user && isMEXMarket) {
          newPrice.vehicleSuppressedByDealer = !(event.target.value > 0);
        }
      }
      return newPrice;
    });
    setEditButtonDisable(originalDisables);
    setSelectedPrices(newPrices);
    setPricesApplied(false);
  };

  const clickCheckBox = (event) => {
    const index = event.target.value;
    const originalState = selectedPrices;
    if (originalState && originalState[index]) {
      originalState[index].checked = !originalState[index].checked;
      if (isMEXMarket) {
        originalState[index].vehicleSuppressedByDealer =
          !originalState[index].vehicleSuppressedByDealer;
        originalState[index].published = false;
      }
      const filteredPrice = originalState.filter(
        (invprice) => invprice.checked === true
      );
      setSelectedPrices(originalState);
      setAllChecked(checkIfAllChecked(filteredPrice));
      setPricesApplied(false);
    }
  };

  const checkIfAllChecked = (filteredPrice) => {
    return filteredPrice.length === selectedPrices.length;
  };

  const fillAllCheckBox = () => {
    const checkedOrNot = !allChecked;
    const allPrices = selectedPrices;
    allPrices.forEach((invprice) => {
      if (invprice.vin !== "") {
        if (invprice.priceModified) {
          invprice.checked = true;
        } else {
          invprice.checked = checkedOrNot;
        }
      }
    });
    setSelectedPrices(allPrices);
    setAllChecked(checkedOrNot);
  };

  const updatePriceModifiedFlag = (modifiedPrices) => {
    modifiedPrices.forEach((modified) => {
      selectedPrices.forEach((price) => {
        if (modified.vin === price.vin) {
          price.priceModified = false;
          price.checked = false;
        }
      });
    });
  };

  const uploadInventoryPrices = () => {
    const modifiedPrices = selectedPrices.filter((price) => price.checked);
    props.hideOrShow(true);

    const listOfDealers = addDealerObjectsInIALrequest(props.user);

    const requestBody = {
      dealerInfos: listOfDealers,
      prices: modifiedPrices,
    };
    let reload = false;
    UploadDealerPriceClient.persistAndPublishToIAL(props.user, requestBody)
      .then((data) => {
        if (data && data.message && data.message.code === "200") {
          reload = true;
        } else if (data && data.message && data.message.code === "500") {
          throw new Error("IAL Call Failed:" + data.message.description);
        }
      })
      .catch(() => {
        const errorMessage = props.t("UploadDealerPrice.ialErrorMessage");
        setErrorMsg(errorMessage);
        setIalErrorOpen(true);
      })
      .finally(() => {
        if (reload) {
          props.loadDealerInventoryPricingHistory();
          setNumberOfPricesPublished(modifiedPrices.length);
          setIsEditable(false);
          setEditButtonDisable({});
          setAllChecked(false);
          setPricesApplied(true);
        }
        props.hideOrShow(false);
      });
    updatePriceModifiedFlag(modifiedPrices);
  };

  return (
    <div className="pageWrapper">
      {!props.fromQuickstart && getSubNav()}

      <ShowInventoryData
        {...props}
        open={openModal}
        cancel={handleClose}
        closeModal={toggleModal}
        showUsdCustomerPrice={props.t("UploadDealerPrice.showUsdCustomerPrice")}
        uploadDealerPriceToSave={uploadDealerPriceToSave}
        toggleModal={toggleModal}
        checkAllCheckBox={fillAllCheckBox}
        allChecked={allChecked}
        selectedPrices={fileExtractingData}
        conversionRate={conversionRate}
        isMEXMarket={isMEXMarket}
      />
      <div className={styles.title}>
        <h2 className="pagePaddingLeft" id="termsHeader">
          {props.t("UploadDealerPrice.title")}
        </h2>
      </div>

      <form
        id="modifyReservationForm"
        ref={props.formRef}
        onSubmit={(e) => {
          e.preventDefault();
          uploadInventoryPrices();
        }}
      >
        <LoadDealerPricing
          {...props}
          showValidatdColumn={true}
          showUsdCustomerPrice={props.t(
            "UploadDealerPrice.showUsdCustomerPrice"
          )}
          editMode={isEditable}
          editReservations={(e) => EditReservationsHandler(e)}
          clickCheckBox={(e) => clickCheckBox(e)}
          updateInventoryPrice={updateInventoryPrice}
          allChecked={allChecked}
          checkAllCheckBox={fillAllCheckBox}
          selectedPrices={selectedPrices}
          conversionRate={conversionRate}
          isMEXMarket={isMEXMarket}
        />
        {getCount() > 0 && getCountForEdit() && !pricesApplied ? (
          <div className={styles.buttonDiv}>
            <button id="saveBtn" className={commonStyles.greenBtn}>
              {`${props.t("ActionFooter.apply")} `}
            </button>
          </div>
        ) : (
          numberOfPricesPublished > 0 && (
            <PricesApplied
              success={pricesApplied}
              text={`${numberOfPricesPublished} ${props.t(
                "ModifyReservationPrice.vinsPublishedSuccessfully"
              )}`}
            />
          )
        )}
      </form>
      <PricesApplied
        success={pricesUploaded}
        text={`${numberOfPricesUploaded} ${props.t(
          "ModifyReservationPrice.vinsUploadedSuccessfully"
        )}`}
      />
      {ialErrorOpen && (
        <ErrorProcessingDialog
          open={ialErrorOpen}
          close={() => {
            setIalErrorOpen(false);
            setDisplayDetails(false);
          }}
          body={errorMsg}
        />
      )}
    </div>
  );
};

export default withTranslation("emp")(UploadDealerPricing);
